export default (value) => {

    return this.$moment(value).format('DD/MM/YYYY HH:mm');
}
